import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import appointmentStyles from "../../../styles/userDetails/appointmentScheduler.module.css";
import CustomDatePicker from './customDatePicker';
import holidaysListClient from '../../../utility/features/api_clients/holidaysList/holidaysListClient.js';
import Loader from '../../loader/index.js';
import toggleHolidayClient from '../../../utility/features/api_clients/holidaysList/toggleHolidayClient.js';
import addHolidayClient from '../../../utility/features/api_clients/holidaysList/addHolidayClient.js';

const HolidaysList = ({handleBackFromHolidays}) => {
    const [holidays, setHolidays] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newDate, setNewDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isHolidayAdded, setIsHolidayAdded] = useState(false);
    const [isHolidayToggled, setIsHolidayToggled] = useState(false);
    const [deleteShowModal, setDeleteShowModal] = useState(false);
    const [deleteHolidayDate, setDeleteHolidayDate] = useState(false);
    const [addHolidayErrorMessage, setAddHolidayErrorMessage] = useState("");
    const [deleteHolidayErrorMessage, setDeleteHolidayErrorMessage] = useState("");
    const [addLoading, setAddLoading] = useState("");


    useEffect(() => {
        setLoading(true);
        const getHolidaysList = async () => {
            try {
                const resp = await holidaysListClient();
                if (resp.status === 200) {
                    setHolidays(resp.data);
                }
            } catch (err) {
                console.log("Error fetching holiday list:", err);
            }
            setLoading(false);
        }
        getHolidaysList();
    }, [isHolidayAdded, isHolidayToggled]);

    const filteredActiveHolidays = holidays.filter(holiday => holiday.isActive !== 0);

    // Parse an API date in YYYY-MM-DD as a *local* date (avoids timezone shifting to previous day)
    const parseYMDToLocalDate = (value) => {
        if (value instanceof Date) return value;
        if (typeof value !== 'string') return null;

        const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
        if (!match) return null;

        const year = Number(match[1]);
        const monthIndex = Number(match[2]) - 1;
        const day = Number(match[3]);
        return new Date(year, monthIndex, day);
    };

    // Format date to "28th Nov 2025" format
    const formatDate = (dateString) => {
        const date = parseYMDToLocalDate(dateString) || new Date(dateString);
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) return String(dateString || '');
        const day = date.getDate();
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        
        // Add ordinal suffix
        const getOrdinalSuffix = (day) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };
        
        return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
    };

    const toYMD = (date) => {
    if (!(date instanceof Date)) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 0-based month
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
    }

    const handleHolidaysClick = () => {
        setShowModal(true);
    };

    const handleSubmitHoliday = async () => {
        if (!newDate) {
            setAddHolidayErrorMessage('Please select a date.');
            return;
        }
        
        // Convert date to YYYY-MM-DD format
        const dateStr = toYMD(new Date(newDate));
        // Check if date already exists
        const dateExists = holidays.some(holiday => holiday.holiday === dateStr);
        
        setIsHolidayAdded(false);
        if (dateExists) {
            const existingDate = holidays.filter(holiday => holiday.holiday === dateStr)[0];
            if (existingDate.isActive === 1) {
                setAddHolidayErrorMessage("Holiday already Exist. Please use a different Holiday!");
                return;
            }
            else {
                const newHoliday = {
                    holiday: dateStr,
                    isActive: true
                };
               
                setAddLoading(true);
                try {
                    const result = await toggleHolidayClient(newHoliday);

                    if (result.status === 200 && result.data.messageCode === 200) {
                       setNewDate(null);
                        setShowModal(false); 
                        setIsHolidayAdded(true);
                    } else {
                        setAddHolidayErrorMessage(result.data?.message || 'Something went wrong');
                    }
                } catch (err) {
                    setAddHolidayErrorMessage(err?.message || 'Network error');
                } finally {
                    setAddLoading(false);           
                }
            }
        }

        else {
            const newHoliday = {
                 holiday: dateStr
            };
            setAddLoading(true);
            try {
                const result = await addHolidayClient(newHoliday);

                if (result.status === 200 && result.data.messageCode === 200) {
                   setNewDate(null);
                    setShowModal(false); 
                    setIsHolidayAdded(true);
                } else {
                    setAddHolidayErrorMessage(result.data?.message || 'Something went wrong');
                }
            } catch (err) {
                setAddHolidayErrorMessage(err?.message || 'Network error');
            } finally {
                setAddLoading(false);           
            }
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setNewDate(null);
        setShowCalendar(false);
        setAddHolidayErrorMessage("");

    };

    const handleCalendarIconClick = () => {
        setShowCalendar(!showCalendar);
        setAddHolidayErrorMessage("");
    };

    const handleShowDeleteModal = (holiday) => {
        setDeleteShowModal(true);
        setDeleteHolidayDate(holiday)
    }

    const handleDeleteCloseModal = () => {
        setDeleteShowModal(false);
        setDeleteHolidayErrorMessage("");
    };

    const handleDelete = async () => {
        setIsHolidayToggled(false);
        const holidayBody = {
            holiday: deleteHolidayDate,
            isActive: false
        }

    try {
        const result = await toggleHolidayClient(holidayBody);
        if (result.status === 200 && result.data.messageCode === 200) {
            setIsHolidayToggled(true);
            setDeleteShowModal(false);
        } else {
            setDeleteHolidayErrorMessage(result.data?.message || 'Failed to toggle holiday');
        }
    } catch (err) {
        console.log(err,"Error deleting holiday");
    }
    };

    return (
        <div className="container mt-3">
            <div className="position-relative d-flex justify-content-between align-items-center">
            </div>
            <div className='row py-2'>
                <div className='col-md-6'>
                      <button
                        type="button"
                        className={`btn btn-secondary mb-3`}
                        onClick={handleBackFromHolidays}
                    >
                        &larr; Back to Branch List
                    </button>
                </div>
                <div className="col-md-6 d-flex justify-content-end py-2">
                    <button
                        type="button"
                        className={`btn btn-info ${appointmentStyles["bg-green"]}`}
                        onClick={handleHolidaysClick}
                    >
                        Add Holiday
                    </button>
                </div>
            </div>

            {/* Add Holiday Modal */}
            {showModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add New Holiday</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    {/* <label htmlFor="holidayDate" className="form-label" style={{
                                        fontWeight: '500',
                                        color: '#2c3e50',
                                        marginBottom: '0.75rem'
                                    }}>
                                        Select Holiday Date
                                    </label> */}
                                    <div className="input-group mb-2" style={{
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
                                    }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Click calendar icon to select date"
                                            value={newDate ? formatDate(toYMD(newDate)) : ''}
                                            readOnly
                                            style={{
                                                background: 'rgba(255, 255, 255, 0.7)',
                                                backdropFilter: 'blur(10px)',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                borderRight: 'none',
                                                color: '#2c3e50',
                                                fontWeight: '500',
                                                padding: '0.75rem 1rem',
                                                fontSize: '0.95rem',
                                                boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)',
                                                cursor: 'pointer'
                                            }}
                                        />
                                        <button
                                            className="btn"
                                            type="button"
                                            onClick={handleCalendarIconClick}
                                            title="Select Date"
                                            style={{
                                                background: 'rgba(255, 255, 255, 0.8)',
                                                backdropFilter: 'blur(10px)',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                borderLeft: '1px solid rgba(200, 200, 200, 0.3)',
                                                color: '#5a67d8',
                                                padding: '0.75rem 1.25rem',
                                                transition: 'all 0.3s ease',
                                                boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(90, 103, 216, 0.15)';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.color = '#4c51bf';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.8)';
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.color = '#5a67d8';
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                                            </svg>
                                        </button>
                                    </div>
                                    {showCalendar && (
                                        <CustomDatePicker
                                            value={newDate}
                                            onChange={(date) => {
                                                setNewDate(date);
                                                setShowCalendar(false);
                                            }}
                                            highlightedDates={holidays.map(h => h.holiday)}
                                        />
                                    )}
                                </div>
                                <div>
                                    {addLoading ? <p>Submitting...</p> : <p className='text-danger'>{addHolidayErrorMessage}</p>}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCloseModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-primary ${appointmentStyles["bg-green"]}`}
                                    onClick={handleSubmitHoliday}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Holiday Modal */}
            {deleteShowModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete Holiday</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleDeleteCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label htmlFor="holidayDate" className="form-label">
                                        Are you sure you want to delete this holiday?
                                    </label>
                                </div>
                                <div>
                                   <p className='text-danger'>{deleteHolidayErrorMessage}</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleDeleteCloseModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-primary ${appointmentStyles["bg-green"]}`}
                                    onClick={handleDelete}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* </div> */}

            {loading ? <Loader />
                : <div className="row g-4">
                    {filteredActiveHolidays.length > 0 ? (
                        filteredActiveHolidays.map((holiday) => {
                            return (
                                <div key={holiday.holiday} className="col-md-4 col-sm-6">
                                    <div className="card shadow-sm h-100 border-0" style={{ 
                                        borderRadius: '12px',
                                        transition: 'transform 0.2s, box-shadow 0.2s'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                    }}>
                                        <div className="card-body d-flex justify-content-between align-items-center p-4">
                                            <div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#6c757d" viewBox="0 0 16 16" className="me-2">
                                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                                                    </svg>
                                                    <span className="text-muted small">Holiday</span>
                                                </div>
                                                <h5 className="card-title mb-0" style={{ 
                                                    fontSize: '1.25rem',
                                                    fontWeight: '600',
                                                    color: '#2c3e50'
                                                }}>
                                                    {formatDate(holiday.holiday)}
                                                </h5>
                                            </div>
                                            <button
                                                onClick={() => handleShowDeleteModal(holiday.holiday)}
                                                className="btn btn-outline-secondary"
                                                style={{
                                                    borderRadius: '8px',
                                                    fontWeight: '400',
                                                    padding: '0.5rem 1rem',
                                                    borderColor: '#dee2e6',
                                                    color: '#6c757d',
                                                    transition: 'all 0.2s',
                                                    whiteSpace: 'nowrap',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                    e.currentTarget.style.borderColor = '#adb5bd';
                                                    e.currentTarget.style.color = '#495057';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                    e.currentTarget.style.borderColor = '#dee2e6';
                                                    e.currentTarget.style.color = '#6c757d';
                                                }}
                                                title="Delete Holiday"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" className="me-2">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                </svg>
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="col-12">
                            <div className="alert alert-info text-center" role="alert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" className="mb-3">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                </svg>
                                <h5>No holidays added yet</h5>
                                <p className="mb-0">Click "Add Holiday" to create your first holiday.</p>
                            </div>
                        </div>
                    )}
                </div>
            }
        </div>
    );
};

export default HolidaysList;


